import { useRef, forwardRef, useImperativeHandle } from 'react'
import { Controller, useFieldArray } from 'react-hook-form'
import { XMarkIcon, PlusIcon } from '@heroicons/react/20/solid'

import SuggestionField from '../../contacts/form/SuggestionField'

// Utiliser forwardRef pour pouvoir passer une référence depuis le parent
const ContactFields = forwardRef(({control, nature = "", validator = {}, selectedCallBack = () => {}}, ref) => {
  const contactRefs = useRef([])

  // Utilisation de useFieldArray pour gérer un tableau de contacts 
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "contacts"
  })

  // Exposer la méthode resetFields au parent via la référence
  useImperativeHandle(ref, () => ({
    // Méthode que le parent pourra appeler pour réinitialiser les champs
    resetFields: () => {
      if (fields.length > 0) {
        replace([])
      }
    }
  }))
 
  return (
    <>
    <div>
      {fields.map((values, index) => (
        <div key={values.id} className="mb-4 relative">
          {/* Afficher le bouton de suppression seulement s'il y a plus d'un contact */}
          {fields.length > 1 && (
            <button 
              type="button"
              className="btn btn-circle btn-xs btn-ghost bg-base-200 hover:bg-base-300 absolute top-[25%] left-[-1.75rem]"
              onClick={() => remove(index)}
              title="Supprimer ce contact"
            >
              <XMarkIcon className='h-4 w-4'/>
            </button>
          )}
          
          <Controller
            name={`contacts.${index}`}
            control={control}
            render={({ field }) => (
              <SuggestionField
                ref={(el) => contactRefs.current[index] = el}
                contactField={{
                  ...field,
                  onChange: (v) => {
                    field.onChange(v)
                    selectedCallBack()
                  }
                }}
                nature={nature}
                originalData={values}
                hasError={validator.hasError ? validator.hasError(`contacts.${index}`) : false}
                errorMessage={validator.getErrorMessage ? validator.getErrorMessage(`contacts.${index}`) : ''}
                label={`Contact ${index + 1}`}
              />
            )}
          />
        </div>
      ))}
      
      {/* Bouton pour ajouter un nouveau propriétaire */}
      <div className="flex flex-col space-x-2">
        <button
          type="button"
          className="btn btn-outline new-owner"
          onClick={() => {
            append({ })
            setTimeout(() => {
              const lastIndex = fields.length
              if (contactRefs.current[lastIndex]) {
                contactRefs.current[lastIndex].focus()
              }
            }, 100)
          }}
        >
          <PlusIcon className="h-4 w-4 mr-1"/>
          Ajouter un contact
        </button>         
      </div>
    </div>
    </>
  )
})

// Exporter le composant avec forwardRef
export default ContactFields